module.exports = __webpack_public_path__ + "img/solution-electric-function-icon-4.d2111bb9.svg";